var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar"},[_c('a-icon',{staticClass:"trigger",attrs:{"type":_vm.collapsed ? 'menu-unfold' : 'menu-fold'},on:{"click":_vm.changeCollapsed}}),_c('ul',{staticClass:"menu"},[_c('li',{staticClass:"user"},[_c('user-menu')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }